import {
  MutationFunction,
  QueryKey,
  useMutation as reactQueryMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { extractReactQueryKey } from 'utils';

export const useInvalidationMutation = <
  TData,
  TError = unknown,
  TVariables = unknown,
  TContext = unknown,
>(
  key: QueryKey,
  query: MutationFunction<TData, TVariables>,
  options?: UseMutationOptions<TData, TError, TVariables, TContext>,
) => {
  const queryClient = useQueryClient();

  return reactQueryMutation({
    mutationFn: query,
    ...options,
    onSuccess: (a, b, c, d) => {
      queryClient.invalidateQueries({ queryKey: extractReactQueryKey(key) });
      options?.onSuccess?.(a, b, c, d);
    },
  });
};
